import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EB5A0A",
      d: "M28 0c15.464 0 28 12.536 28 28S43.464 56 28 56 0 43.464 0 28 12.536 0 28 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M20.922 19.1a2.82 2.82 0 0 0-2.82 2.82v9.6a2.82 2.82 0 0 0 2.82 2.82h1.02V37a.9.9 0 0 0 1.41.74l4.93-3.4h6.08a2.82 2.82 0 0 0 2.82-2.82v-9.6a2.82 2.82 0 0 0-2.82-2.82zm1.02 5.216a.9.9 0 0 1 .9-.9h9.6a.9.9 0 0 1 0 1.8h-9.6a.9.9 0 0 1-.9-.9m.9 3.42a.9.9 0 0 0 0 1.8h6.72a.9.9 0 1 0 0-1.8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }